module.exports = __webpack_public_path__ + "img/4.e7a7f713.png";